import logoLockup from '../../assets/bliss-basic-logo-lockup.png'

type Props = {
  className?: string
  /** nav = header; hero = larger lockup above headline */
  variant?: 'nav' | 'hero'
}

/** Official Bliss Basic lockup (transparent PNG) — bundled so SPA rewrites cannot 404 it. */
export default function BlissBasicLogo({ className = '', variant = 'nav' }: Props) {
  return (
    <img
      src={logoLockup}
      alt=""
      role="img"
      aria-label="Bliss Basic"
      className={`bliss-basic-logo bliss-basic-logo--${variant}${className ? ` ${className}` : ''}`.trim()}
      decoding="async"
    />
  )
}
